// @ts-nocheck
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { HasProduct, withProduct } from "@insite/client-framework/Components/ProductContext";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import LazyImage from "@insite/mobius/LazyImage";
import constants from "@store/constants";
import useParentProductState from "@store/Framework/Store/Foundation/Data/Products/ProductsHooks/useParentProductState";
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
import React, { FC } from "react";
import { css } from "styled-components";

const enum fields {
    seriesBadgeWidth = "seriesBadgeWidth",
}

interface OwnProps extends WidgetProps {
    fields: {
        [fields.seriesBadgeWidth]: number;
    };
}

type Props = HasProduct & OwnProps;

const ProductSeriesBadge: FC<Props> = ({ product, fields: { seriesBadgeWidth } }) => {
    const style = {
        css: css`
            width: 100%;
            max-width: ${pxToRem(seriesBadgeWidth)};
            margin: 0;
        `,
    };

    const parentProductState = useParentProductState();

    if (!product) {
        return null;
    }

    const productSeriesBadge = product.images?.filter(i => i.name.includes(constants.imageTypes.seriesBadges)).shift();
    const parentSeriesBadge = parentProductState?.images
        ?.filter(i => i.name.includes(constants.imageTypes.seriesBadges))
        .shift();

    if (!productSeriesBadge && !parentSeriesBadge) {
        return null;
    }

    const seriesBadge = productSeriesBadge || parentSeriesBadge;

    if (!seriesBadge) {
        return null;
    }

    return (
        <StyledWrapper {...style}>
            <LazyImage src={seriesBadge.mediumImagePath} altText={seriesBadge.imageAltText} />
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: withProduct(ProductSeriesBadge),
    definition: {
        displayName: "Series Badge",
        group: "Product Details",
        allowedContexts: ["ProductDetailsPage"],
    },
};

export default widgetModule;
